"use client";

import {useState, useSyncExternalStore} from "react";

const KEY = "gail.approval.diffMode";
const EVENT = "gail:approval-diff-mode";
const read = () => {
   try { return localStorage.getItem(KEY) === "inline"; } catch { return false; }
};
const subscribe = (notify: () => void) => {
   window.addEventListener("storage", notify);
   window.addEventListener(EVENT, notify);
   return () => {
      window.removeEventListener("storage", notify);
      window.removeEventListener(EVENT, notify);
   };
};

/** Shared across cards and tabs; unavailable storage never prevents reviewing a proposal. */
export function useApprovalDiffMode() {
   const stored = useSyncExternalStore(subscribe, read, () => false);
   // An in-memory override also allows switching views when browser storage is disabled.
   const [override, setOverride] = useState<boolean | null>(null);
   return [override ?? stored, (inline: boolean) => {
      try {
         localStorage.setItem(KEY, inline ? "inline" : "split");
         setOverride(null);
         window.dispatchEvent(new Event(EVENT));
      } catch { setOverride(inline); }
   }] as const;
}
